// Ported from jonanortizvega/weight-streaming (a8bb5c9), scaleParser /
// frameExtractor / stabilityDetector. Serial framing and units match the bridge.
export const LOCAL_SCALE_FRESHNESS_MS = 8000;
export const LOCAL_SCALE_BAUD_RATES = [9600, 4800, 2400, 19200];

export const parseLocalScaleFrame = (raw) => {
  const line = String(raw || '').replace(/[\x00-\x1F\x7F]+/g, ' ').replace(/\s+/g, ' ').trim();
  // Reject overload/errors and corrupted or multi-value frames instead of weighing
  // an error code, a price, or a partial overflowing input buffer.
  if (!line || /[^\x20-\x7E]/.test(line) || /\b(?:err(?:or)?|overload|ol|ofl)\b/i.test(line)) return null;
  const numbers = line.match(/[+-]?\d+(?:[.,]\d+)?/g);
  if (numbers?.length !== 1) return null;
  const unit = line.match(/(?:kilograms|kilogram|kgr|kgs|kg|grams|gram|gr|g|lbs|lb)\b/i)?.[0]?.toLowerCase();
  let weight = Number(numbers[0].replace(',', '.'));
  if (['g', 'gr', 'gram', 'grams'].includes(unit)) weight /= 1000;
  if (['lb', 'lbs'].includes(unit)) weight *= 0.45359237;
  if (!Number.isFinite(weight)) return null;
  return { weightKg: Number(weight.toFixed(3)), raw: line, unstable: /(?:^|[,\s])US(?:[,\s]|$)/i.test(line) };
};

export class LocalScaleDecoder {
  constructor(onReading) {
    this.onReading = onReading;
    this.decoder = new TextDecoder();
    this.buffer = '';
    this.dropping = false;
  }

  push(bytes) {
    for (const character of this.decoder.decode(bytes, { stream: true })) {
      const code = character.charCodeAt(0);
      if (code < 32 || code === 127) {
        if (!this.dropping) {
          const reading = parseLocalScaleFrame(this.buffer);
          if (reading) this.onReading(reading);
        }
        this.buffer = '';
        this.dropping = false;
      } else if (!this.dropping) {
        this.buffer += character;
        if (this.buffer.length > 256) { this.buffer = ''; this.dropping = true; }
      }
    }
  }
}

export class LocalScaleStability {
  reset() { this.candidate = null; }

  push(reading, now, mode = 'continuous') {
    if (reading.weightKg <= 0) { this.reset(); return 'cleared'; }
    if (reading.unstable) { this.reset(); return 'unstable'; }
    if (mode === 'stable_non_zero') return 'stable';
    const current = this.candidate;
    if (!current || now - current.lastAt > LOCAL_SCALE_FRESHNESS_MS || Math.abs(current.weight - reading.weightKg) > 0.002) {
      this.candidate = { weight: reading.weightKg, startedAt: now, lastAt: now, frames: 1 };
      return 'unstable';
    }
    current.frames += 1;
    current.lastAt = now;
    return current.frames >= 4 && now - current.startedAt >= 900 ? 'stable' : 'unstable';
  }
}
